module.exports = __webpack_public_path__ + "static/media/playstore.d4fd8a05.webp";